import React from "react";

const FAQSection = () => {
  return (
    <section className="w-full">

      {/* CTA BAR */}
      <div className="w-full bg-[#00B3A4]">
        <div className="max-w-6xl mx-auto px-6 py-8 flex flex-col md:flex-row items-center justify-between">
          <p className="text-white text-lg font-semibold mb-4 md:mb-0">
            See How Invexflow fits your workflows
          </p>

          <button className="text-white font-semibold text-sm underline underline-offset-4 hover:opacity-90 transition">
            Start a Free Assessment
          </button>
        </div>
      </div>

    </section>
  );
};

const FAQCard = ({ question, answer }) => {
  return (
    <div className="border border-[#E2E8F0] rounded-xl p-6 hover:shadow-sm transition">
      <h4 className="text-sm font-semibold text-[#0F172A] mb-2">
        {question}
      </h4>
      <p className="text-sm text-[#64748B] leading-relaxed">
        {answer}
      </p>
    </div>
  );
};

export default FAQSection;
